
import Image from "next/image"

export default function Project({ name, title = "", desc = "", images = [], textClass = "text-white", modalHandler = null }) {
  return (
    <div 
      id={"project-" + name} 
      className="project cursor-pointer relative overflow-hidden w-[100%] pb-[56%] lg:w-[30%] lg:pb-[16.5%] h-[0] mx-4 my-4 border border-white transition"
      onClick={ () => modalHandler({ "showModal": true, "mode": name }) }>
      <div className="project-thumb w-full h-full flex justify-center items-center transition pointer-events-auto z-0">
        { images.map( function (value, index, array) {
            return (
              <Image
                className="project-thumb-image pointer-events-none" 
                src={ value }
                key={ index }
                fill={ true }
                alt={ "Project Image for " + name }>
              </Image>
            )
          })
        }
        <div className={ `project-thumb-text flex flex-col ${textClass} pt-[56%] transition select-none pointer-events-none z-50 opacity-0 w-full` }>
          <div className="text-4xl lg:text-lg 2xl:text-5xl mb-6 lg:mb-2 2xl:mb-6 px-6">
            { title }
          </div>
          <div className="text-lg lg:text-sm 2xl:text-xl text-left px-6">
            { desc }
          </div>
        </div>
      </div>
    </div>
  );

}